
import React, { useEffect, useState } from "react";
import JoditEditor from "jodit-react";
import { toast } from 'react-toastify';
import axios from "axios";
import "../../App.css";
import { ApiUrl } from '../../Constants/Weburl'
import joditConfig from "../../components/config/joditconfig";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";
import CustomButton from "../../components/CustomButton";;

const PUBLIC_POLICY_URL = `${window.location.origin}/pages/terms-of-use`;



export default function Terms() {

    const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

    const adminToken = localStorage.getItem("adminToken");

  console.log('adminToken', adminToken);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        // const res = await axios.get("/getterms");
         const res = await axios.get(`${ApiUrl}api/getterms`, {
          headers: { Authorization: `Bearer ${adminToken}` }
        });
        setContent(res.data?.data?.content || "");
      } catch (err) {
        toast.error("Failed to load terms of use");
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  const handleSave = async () => {
    if (!content.trim()) {
      toast.error("Content cannot be empty");
      return;
    }
    try {
      setSaving(true);
       await axios.put(`${ApiUrl}api/saveterms`, { content }, {
        headers: {
          Authorization: `Bearer ${adminToken}`
        }
      });
      toast.success("Terms of use saved");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Layout>
        <SettingsPageShell
          title="Terms of Use"
          headerRight={
            <button
              className="ls-save-btn"
              onClick={() => window.open(PUBLIC_POLICY_URL, "_blank")}
            >
              View
            </button>
          }
        >
          <div className="ls-card">
            {!loading && (
              <JoditEditor
                value={content}
                config={joditConfig}
                onBlur={(newContent) => setContent(newContent)}
              />
            )}

            <CustomButton
              type="button"
              className="ls-save-btn"
              onClick={handleSave}
              disabled={saving || loading}
            >
              {saving ? "Saving..." : "Save"}
            </CustomButton>
          </div>
        </SettingsPageShell>
      </Layout>
    </>
  );
}

  // return (
  //     <>
  //      <Layout>
  //        <SettingsPageShell
  //         title="Terms Of Uses"
  //         headerRight={
  //           <button
  //             className="ls-save-btn"
  //           >
  //            View
  //           </button>
  //         }
  //       >
       

  //           <div className="ls-card">
            

  //            <JoditEditor
  //             value={content}
  //             config={joditConfig}
  //             onBlur={(newContent) => {
  //               setContent(newContent);
  //             }}
  //           />


  //             <div >

  //             <CustomButton
  //               type="button"
  //               className="ls-save-btn"
              
  //             >
  //               Save
  //             </CustomButton>

  //           </div>


  //            </div>
      
  //       </SettingsPageShell>
    
  //                </Layout>
  //    </>
  // );



